import { ComponentPropsWithRef, memo } from 'react';
import { isUndefined } from 'lodash-es';
import { IconSize } from '../../../types';
// TODO: remove comment when prettier will be updated
import type { IconsMap } from './icons';
import { IconSVGComponent } from './IconSVGComponent';

import styles from './index.module.css';

interface Props extends ComponentPropsWithRef<'svg'> {
  dataRole?: string;
  size?: IconSize;
  name: keyof IconsMap | (string & NonNullable<unknown>);
  color?: string;
  fill?: string;
}

// TODO: name suggestions doesn't work because we need to make a typization for theme at first.
//       and then we will have and ability to suggest theme icons as well as default icons
// TODO: some properties could be deprecated and/or we can provide css api for that
export const Icon = memo(
  ({
    name,
    size = 'l',
    className = '',
    color,
    style,
    fill,
    dataRole,
    ...props
  }: Props) => {
    const iconStyle = isUndefined(fill) ? styles.icon : '';
    const extStyles = fill ? { fill } : {};

    return (
      <IconSVGComponent
        className={`${iconStyle} ${styles[`s_${size}`]} ${className}`}
        style={
          color
            ? { ...style, color: `var(--${color})` }
            : { ...style, ...extStyles }
        }
        name={name}
        dataRole={dataRole}
        {...props}
      />
    );
  }
);
